// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"5a9dd3a0","769":"85c26d36"}[chunkId] + ".chunk.js";
};